import Cookies from "js-cookie"
import { v4 } from 'uuid'
import { BizzeySetting } from "../../../packs/widget_shim"

class CookieHelper {
  static initialise(settings: BizzeySetting) {
    const widgetId = settings.app_id
    // Set device id if not already present
    this.upsertDeviceId(widgetId)

    // Set anonymous identifier if not already present
    this.upsertAnonymousIdentifier(widgetId)

    // Set session id if not already present
    if (settings.user_id) {
      this.setSessionIdentifier(widgetId, settings.user_id)
    } else {
      this.removeSessionIdentifier(widgetId)
    }
  }

  static upsertDeviceId(widgetId) {
    const deviceId = this.getDeviceId(widgetId)

    if (!deviceId) {
      const newDeviceId = v4()
      this.setDeviceId(widgetId, newDeviceId)
    }
  }

  static getDeviceId(widgetId: string) {
    return Cookies.get(`bizzey-device-id-${widgetId}`)
  }

  static setDeviceId(widgetId: string, deviceId: string) {
    return Cookies.set(`bizzey-device-id-${widgetId}`, deviceId, { expires: 273.75 })
  }

  static upsertAnonymousIdentifier(widgetId: string) {
    const anonymousIdentifier = this.getAnonymousIdentifier(widgetId)

    if (!anonymousIdentifier) {
      const newAnonymousIdentifier = v4()
      this.setAnonymousIdentifier(widgetId, newAnonymousIdentifier)
    }
  }

  static getAnonymousIdentifier(widgetId: string) {
    return Cookies.get(`bizzey-id-${widgetId}`)
  }

  static setAnonymousIdentifier(widgetId: string, id: string) {
    Cookies.set(`bizzey-id-${widgetId}`, id, { expires: 273.75 })
  }

  static getSessionIdentifier(widgetId: string) {
    return Cookies.get(`bizzey-session-id-${widgetId}`)
  }

  static setSessionIdentifier(widgetId: string, id: string) {
    Cookies.set(`bizzey-session-id-${widgetId}`, id, { expires: 273.75 })
  }

  static removeSessionIdentifier(widgetId: string) {
    Cookies.remove(`bizzey-session-id-${widgetId}`)
  }
}

export default CookieHelper